export const DefaultPermissions = {
  /**
   * 센터 정보 수정
   */
  CENTER_UPDATE: 'CENTER_UPDATE',
  /**
   * 센터 삭제
   */
  CENTER_DELETE: 'CENTER_DELETE',
  /**
   * 센터 대표 위임
   */
  CENTER_DELEGATE: 'CENTER_DELEGATE',
} as const;

export const CenterRolePermissions = {
  /**
   * 센터 역할 등록/수정
   */
  CENTER_ROLE_EDIT: 'CENTER_ROLE_EDIT',
  /**
   * 센터 역할 삭제
   */
  CENTER_ROLE_DELETE: 'CENTER_ROLE_DELETE',
} as const;

export const CenterUserPermissions = {
  /**
   * 센터 회원 가입 허가 및 반려
   */
  CENTER_USER_APPROVE: 'CENTER_USER_APPROVE',
  /**
   * 센터 회원 추방
   */
  CENTER_USER_KICK: 'CENTER_USER_KICK',
  /**
   * 센터 회원 권한 수정
   */
  CENTER_USER_ROLE_UPDATE: 'CENTER_USER_ROLE_UPDATE',
  /**
   * 센터 회원 그룹 관리
   */
  CENTER_USER_GROUP_MANAGE: 'CENTER_USER_GROUP_MANAGE',
} as const;

/**
 * 센터 회원 초대 권한
 */
export const CenterUserInvitePermissions = {
  /**
   * 센터 회원 초대 내역 조회
   */
  CENTER_USER_INVITE_READ: 'CENTER_USER_INVITE_READ',
  /**
   *  센터 회원 초대
   */
  CENTER_USER_INVITE: 'CENTER_USER_INVITE',
} as const;

/**
 * 센터 회원 가입 신청 권한
 */
export const CenterUserJoinRequestPermissions = {
  /**
   * 센터 회원 가입 신청 조회
   */
  CENTER_USER_JOIN_REQUEST_READ: 'CENTER_USER_JOIN_REQUEST_READ',
} as const;

/**
 * 센터 결제 관리 권한
 */
export const CenterPaymentPermissions = {
  CENTER_PAYMENT: 'CENTER_PAYMENT',
} as const;

/**
 * 아동 관리 권한
 */
export const ChildPermissions = {
  /**
   * 아동 조회
   */
  CHILD_READ: 'CHILD_READ',
  /**
   * 아동 등록/수정
   */
  CHILD_EDIT: 'CHILD_EDIT',
  /**
   * 아동 삭제
   */
  CHILD_DELETE: 'CHILD_DELETE',
} as const;

/**
 * 일정 관리 권한
 */
export const SchedulePermissions = {
  /**
   * 일정 조회
   */
  SCHEDULE_READ: 'SCHEDULE_READ',
  /**
   * 일정 등록/수정
   */
  SCHEDULE_EDIT: 'SCHEDULE_EDIT',
  /**
   * 일정 삭제
   */
  SCHEDULE_DELETE: 'SCHEDULE_DELETE',
} as const;

/**
 * 검사 도구 관리
 */
export const ToolPermissions = {
  /**
   * 검사 목록 조회
   */
  TOOL_READ: 'TOOL_READ',
  /**
   * 검사 진행
   */
  TOOL_EDIT: 'TOOL_EDIT',
} as const;

/**
 * 센터 공지사항 권한
 */
export const CenterNoticePermissions = {
  /**
   * 센터 공지사항 조회
   */
  CENTER_NOTICE_READ: 'CENTER_NOTICE_READ',
  /**
   * 센터 공지사항 등록/수정
   */
  CENTER_NOTICE_EDIT: 'CENTER_NOTICE_EDIT',
  /**
   * 센터 공지사항 삭제
   */
  CENTER_NOTICE_DELETE: 'CENTER_NOTICE_DELETE',
} as const;

/**
 * 서비스 관리(템플릿) 권한
 */
export const CenterTemplatePermissions = {
  /**
   * 서비스 관리 조회
   */
  CENTER_TEMPLATE_READ: 'CENTER_TEMPLATE_READ',
  /**
   * 서비스 관리 등록/수정
   */
  CENTER_TEMPLATE_EDIT: 'CENTER_TEMPLATE_EDIT',
  /**
   * 서비스 관리 삭제
   */
  CENTER_TEMPLATE_DELETE: 'CENTER_TEMPLATE_DELETE',
} as const;

/**
 * 수납 관리 권한
 */
export const BillingPermissions = {
  /**
   * 본인 아동 수납만 조회
   */
  BILLING_READ_SELF: 'BILLING_READ_SELF',
  /**
   * 전체 조회
   */
  BILLING_READ_ALL: 'BILLING_READ_ALL',
  /**
   * 수납 등록/수정
   */
  BILLING_EDIT: 'BILLING_EDIT',
  /**
   * 수납 삭제
   */
  BILLING_DELETE: 'BILLING_DELETE',
} as const;

/**
 * 행정 관리
 */
export const AdministrationPermissions = {
  /**
   * 본인 회계정보만 조회
   */
  ADMINISTRATION_READ_SELF: 'ADMINISTRATION_READ_SELF',
  /**
   * 행정 관리 조회
   */
  ADMINISTRATION_READ: 'ADMINISTRATION_READ',
  /**
   * 행정 관리 등록/수정
   */
  ADMINISTRATION_EDIT: 'ADMINISTRATION_EDIT',
  /**
   * 행정 관리 삭제
   */
  ADMINISTRATION_DELETE: 'ADMINISTRATION_DELETE',
} as const;

/**
 * 치료 문서 관리
 */
export const TherapyDocumentPermissions = {
  /**
   * 치료 문서 관리 조회
   */
  THERAPY_DOCUMENT_READ: 'THERAPY_DOCUMENT_READ',
  /**
   * 치료 문서 관리 등록/수정
   */
  THERAPY_DOCUMENT_EDIT: 'THERAPY_DOCUMENT_EDIT',
  /**
   * 치료 문서 관리 삭제
   */
  THERAPY_DOCUMENT_DELETE: 'THERAPY_DOCUMENT_DELETE',
} as const;
